import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import BASE_URL from "components/BaseUrl/apiConfig";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Navbar from "components/Navbars/AuthNavbar";
import Footer from "components/Footers/Footer";
import BlockUiOverlay from "../Expense/BlockUiOverlay";

function SendEmailReport() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const sendReportEmail = async () => {
      try {
        // Call the API to trigger report sending
        const reportResponse = await fetch(
          `${BASE_URL}/api/Expense/GetMessagesReport`,
          {
            method: "GET", // No body needed for GET
          }
        );

        if (reportResponse.ok) {
          Swal.fire({
            title: "Success!",
            text: "Messages report has been sent successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Failed to send messages report.",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      } catch (error) {
        console.error("Error sending report:", error);
        Swal.fire({
          title: "Error!",
          text: "An error occurred while sending the report.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    };

    // Call the function on component mount
    sendReportEmail();
  }, []); // Empty dependency array means this will run only once when the component mounts

  return (
    <>
      {/* <Navbar /> */}
      <div className="cust-div">
        <BlockUiOverlay visible={loading} />
        <div className="container mx-auto p-4">
          <div className="flex items-center mb-3"></div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default SendEmailReport;
